import {
    Grid,
    Stack,
} from '@mantine/core';
import {RecentInvoicesWidget} from './dashboard/RecentInvoicesWidget';
import {RecentSubscriptionsWidget} from './dashboard/RecentSubscriptionsWidget';
import {RecentCustomersWidget} from './dashboard/RecentCustomersWidget';
import {QuickActionsWidget} from './dashboard/QuickActionsWidget';
import {BalanceWidget} from './dashboard/BalanceWidget';
import {useVerifiedPermissions} from '../../../hooks/useVerifiedPermissions';
import {rbacActions} from '../../../config/rbac/actions';

export const PortalDashboard = () => {

    const {allowedActions} = useVerifiedPermissions();

    return (
        <Stack gap="lg" mx="5%">
            <QuickActionsWidget/>

            <Grid align="stretch">
                <Grid.Col span={{base: 12, lg: 6}}>
                    <Stack gap="lg" h="100%">
                        {allowedActions.includes(rbacActions.ListInvoices) && <RecentInvoicesWidget/>}
                        {allowedActions.includes(rbacActions.ListCustomers) && <RecentCustomersWidget/>}
                    </Stack>
                </Grid.Col>
                <Grid.Col span={{base: 12, lg: 6}}>
                    <Stack gap="lg" h="100%">
                        {allowedActions.includes(rbacActions.ListSubscriptions) && <RecentSubscriptionsWidget/>}
                        {allowedActions.includes(rbacActions.GetBalance) && <BalanceWidget/>}
                    </Stack>
                </Grid.Col>
            </Grid>
        </Stack>
    );
};
